import React, {useContext, useEffect, useRef, useState} from 'react';
import Input from "../../master/Input";
import SearchablePicker from "../../master/SearchablePicker";
import {url} from "../../../utils/variables";
import ImagePickerModal from "../../master/ImagePickerModal";
import Modal from "../../master/Modal";
import ImageZoom from '../../master/ImageZoom';
import { useTranslation } from 'react-i18next';
import { getDirection, pexios, toast, validate } from '../../../utils/functions';
import { TitleContext } from '../../../App';
import DatePicker from '../../master/DatePicker';
import { TimePicker } from '../../master/TimePicker';


export default function AccidentData({ data, changeData, uploadImage, changeStep, submit }) {

    const [imageUID, setImageUID] = useState(null);
    const { t, i18n } = useTranslation();
    const form = useRef(null)

    const accidentType = [
        {title: t('Financial'), value: 'finance'},
        {title: t('Life'), value: 'life'},
        {title: t('Financial and life'), value: 'both'},
    ];
    const [causes,setCauses] = useState([])
    const [payBranches,setPayBranches] = useState([])
    // const {setTitle} = useContext(TitleContext)
    // useEffect(()=>{
    //     setTitle(t('Accident info'))
    // },[])
    useEffect(() => {
        pexios('api/get_coding_data/cause')
            .then(res => {
                setCauses(res.data);
            });
    }, []);
    useEffect(() => {
        pexios(`api/get_pay_branch/${data.accident_id}`)
            .then(res => {
                setPayBranches(res.data);
            });
    }, []);
    const [accidentTime ,setAccidentTime ] = useState({
        date: data.crash_time?.split(' ')[0] || '',
        time: data.crash_time?.split(' ')[1] || ''
    });


    // const because = [
    //     // 'عدم توجه به جلو   (علل حادثه ساز-قانون قديم)',
    //     // 'عدم رعايت فاصله جانبي(علل حادثه ساز-قانون قديم)',
    //     // 'عبور از چراغ قرمز',
    //     // 'عدم رعايت حق تقدم',
    //     // 'حرکات نمايشي در سطح راهها و خيابانها',
    //     // 'دور زدن در محل ممنوع',
    //     // 'عبور وسايل نقليه از پياده رو',
    //     // 'نقص سيستم روشنايي وسايل نقليه به هنگام شب',
    //     // 'عبور ممنوع',
    //     // 'سبقت غير مجاز',
    //     // 'تجاوز از سرعت مجاز',
    //     // 'حرکت بطور مارپيچ در راه ها',
    //     // 'گردش به چپ يا به راست در محل ممنوع',
    //     // 'تجاوز  به سمت چپ  ازمحور راه(علل حادثه ساز)',
    //     // 'روشن نکردن چراغ هنگام شب و در موقع لزوم',
    //     // 'رانندگي با وسيله نقليه داراي عيب و نقص فني موثر',
    //     // 'عدم رعايت شرايط مندرج در گواهينامه از قبيل استفاده از سمعک، عينک، يا تجهيزات خاص',
    //     // 'مصرف مواد روانگردان و مشروبات الکلي',
    //     // 'حرکت بادنده عقب در آزادراهها و بزرگراهها',
    //     // 'عدم رعايت فاصله طولي (علل حادثه ساز-قانون قديم)',
    //     t('173 clause'),
    //     t('132 clause'),
    //     t('138 clause'),
    //     t('180 clause'),
    //     t('129 and 120 clause'),
    //     t('126 clause'),
    //     t('135 clause'),
    //     t('118 and 119 clause'),
    //     t('Right 118 and 119 clause'),
    //     t('122 clause'),
    //     t('155 clause'),
    //     t('200 clause'),
    //     t('119 and 209 clause'),
    //     t('84 and 86 clause'),
    //     t('101 clause'),
    //     t('154 clause'),
    //     t('152 clause'),
    //     t('Etcetra'),
    // ];

    // function nextStep() {
    //     const has_coroukie_image = data.attachments.filter(img => (img.filename.includes('coroukie_image'))).length;
    //     if(data.has_coroukie === 1 && has_coroukie_image === 0) {
    //         toast(t('Complete required fields',{err:t('Croukie image')}), 'error');
    //     }else {
    //         submit();
    //     }
    // }
    function submitData() {
        const error = validate(form);

        if (error) {
            // toast(`فیلد های اجباری ${error} را پر کنید.`, 'error');
            toast(t('Complete required fields',{err:error}), 'error');
            return;
        }
        submit();
    }

    return (
        <>
            <Modal visible={imageUID}>
                <div className='image-modal'>
                    <i className='fas fa-times'
                       onClick={() => setImageUID(null)}
                    />
                    {/* <img src={`${url}/files?uid=${imageUID}`} alt='img'/> */}
                    <ImageZoom imgUid={imageUID}/>
                </div>
            </Modal>
            <h4 className='mt20 border-title title-text'>{t('Accident info')}</h4>
            <div className={`row ${getDirection(i18n.language) ==='rightToLeft'? 'text-right':'text-left'}`} ref={form}>
                <Input
                    label={t('Accident address')}
                    value={data.address}
                    onChange={value => changeData(value, 'address')}
                />
                <Input
                    label={t('Visit palce address')}
                    value={data.visiting_place}
                    onChange={value => changeData(value, 'visiting_place')}
                />
                <DatePicker
                    label='تاریخ حادثه'
                    value={accidentTime.date}
                    onChange={date => {
                        setAccidentTime(prev => ({...prev , date :date}))
                        changeData(`${date} ${accidentTime.time}`, 'crash_time')
                    }}
                    required
                />
                <TimePicker
                    label='ساعت حادثه'
                    value={accidentTime.time}
                    onChange={time => {
                        setAccidentTime(prev => ({...prev , time :time}))
                        changeData(`${accidentTime.date} ${time}`, 'crash_time')
                    }}
                    required
                />

                {
                    data.has_coroukie === 1 &&
                    <>
                        <Input
                            label={t('Report Series')}
                            value={data.coroukie_serie}
                            onChange={value => changeData(value, 'coroukie_serie')}
                        />
                        <Input
                            label={t('Report serials')}
                            value={data.coroukie_serial}
                            onChange={value => changeData(value, 'coroukie_serial')}
                        />
                        <Input
                            label={t('Report agent')}
                            value={data.coroukie_agent}
                            //col={12}
                            onChange={value => changeData(value, 'coroukie_agent')}
                        />
                        <Input
                            label={t('Report agent code')}
                            value={data.coroukie_agent_code}
                            onChange={value => changeData(value, 'coroukie_agent_code')}
                        />
                    </>
                }
                <SearchablePicker
                    label={t('Accident reason')}
                    value={data.cause_id}
                    data={causes}
                    titleKey='title'
                    valueKey='id'
                    rtl={getDirection(i18n.language) ==='rightToLeft'}
                    placeholder={t('Accident reason')}
                    onSelect={cause => changeData(cause, 'cause_id')}
                    required
                />
                <SearchablePicker
                    label={t('Accident type')}
                    value={data.accident_type}
                    data={accidentType}
                    titleKey='title'
                    valueKey='value'
                    rtl={getDirection(i18n.language) ==='rightToLeft'}
                    placeholder={t('Accident type')}
                    onSelect={type => changeData(type, 'accident_type')}
                />
                <SearchablePicker
                    label='شعبه پرداخت'
                    value={data.pay_branch_id}
                    data={payBranches}
                    titleKey='title'
                    valueKey='id'
                    rtl={getDirection(i18n.language) ==='rightToLeft'}
                    onSelect={branch => changeData(branch, 'pay_branch_id')}
                    required
                />
               
            </div>
            {/* <div className={`input-parent ${getDirection(i18n.language) ==='rightToLeft'?'rtl':"ltr"} mt20 p5`}>
                <textarea
                    //rows='4'
                    placeholder={t('Accident description')}
                    onChange={(e) => changeData(e.target.value,'coroukie_description')}
                    // value={data.description}
                />  
                    </div> */}
            {
                data.has_coroukie === 1 &&
                <div className='gridParent'>
                    <div className='crashGrid'>
                        <p>{t('Croukie image')} 
                        {/* <span style={{color: 'red'}}>* </span> */}
                        </p>
                        <div className='crashGridChild'>
                            {
                                data.attachments
                                    .filter(img => (img.filename.includes('coroukie_image')))
                                    .map((img) => (
                                        <div className='imageBox' key={img.id}>
                                            <img
                                                src={`${url}/files?uid=${img.uid}&width=150&height=150`}
                                                alt='img'
                                                className='img'
                                                onClick={() => setImageUID(img.uid)}
                                            />
                                        </div>
                                    ))
                            }
                            <div className='imageBox'>
                                <ImagePickerModal
                                    renderBtn={
                                        <div className='defaultImage' data-content={t('Add')}/>
                                    }
                                    disableGallery
                                    upload={(img, done) => uploadImage(
                                        img,
                                        `expert_coroukie_image${data.attachments.filter(img => img.filename.includes('expert_coroukie_image')).length + 1}`,
                                        done
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            }
            <div className='d-flex mt20 pr5 pl5'>
                <button
                    onClick={()=> changeStep(4)}
                    className='btn btn-orange btn-block btn-circle-left'
                >
                    {t('Prev step')}
                </button>
                <button
                    onClick={submitData}
                    className='btn btn-white-purple btn-block btn-circle-right'
                >
                    {t('Next step')}
                </button>
            </div>
        </>
    );
}
